/* sm-how-it-works.js
   Slideshow for the How It Works block (snippets/sm-how-it-works.liquid).
   Every slideshow marked data-sm-hiw-slides crossfades to its next image
   every 3 seconds. The snippet leaves the marker off in the theme editor. */
(function () {
  if (window.SMHowItWorks) return;
  window.SMHowItWorks = true;

  function start() {
    var shows = document.querySelectorAll('[data-sm-hiw-slides]');
    Array.prototype.forEach.call(shows, function (wrap) {
      var slides = wrap.querySelectorAll('.sm-mech-slide');
      if (slides.length < 2) return;
      var current = 0;
      setInterval(function () {
        slides[current].classList.remove('active');
        current = (current + 1) % slides.length;
        slides[current].classList.add('active');
      }, 3000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
